import clsx from 'clsx';

import { LoadingIcon } from 'honeydew/Loader';

function CheckBalanceButton({ className, isBalanceLoading, isPinValid, onBalanceCheck }) {
    if (isBalanceLoading) {
        return (
            <div className="flex items-center">
                <LoadingIcon />
            </div>
        );
    }

    return (
        <button
            type="button"
            onClick={onBalanceCheck}
            className={clsx(
                'text-body-sm font-grotesk-bold',
                {
                    'text-grey-light underline': !isPinValid,
                    link: isPinValid,
                },
                className
            )}
            disabled={!isPinValid}
        >
            Check Balance
        </button>
    );
}

export default CheckBalanceButton;
